var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_61_17890",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_61_17890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37882 14.775L17.8538 6.3C18.0538 6.1 18.2913 6 18.5663 6C18.8413 6 19.0788 6.1 19.2788 6.3C19.4788 6.5 19.5788 6.7375 19.5788 7.0125C19.5788 7.2875 19.4788 7.525 19.2788 7.725L10.0788 16.925C9.87882 17.125 9.64549 17.225 9.37882 17.225C9.11215 17.225 8.87882 17.125 8.67882 16.925L4.37882 12.625C4.17882 12.425 4.08299 12.1875 4.09132 11.9125C4.09965 11.6375 4.20382 11.4 4.40382 11.2C4.60382 11 4.84132 10.9 5.11632 10.9C5.39132 10.9 5.62882 11 5.82882 11.2L9.37882 14.775Z",
    fill: "#454E58"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.76146155fbb0584ba07babe33513df70.svg";
export { ForwardRef as ReactComponent };